// var View = com.vizengine.view.View,
//   TextView = com.vizengine.view.TextView,
//   ImageView = com.vizengine.view.ImageView,
//   WebView = com.vizengine.view.WebView,
//   ListView = com.vizengine.view.ListView,
//   ScrollView = com.vizengine.view.ScrollView
// var AlphaAnimation = com.vizengine.animation.AlphaAnimation,
//   TranslateAnimation = com.vizengine.animation.TranslateAnimation,
//   Animation = com.vizengine.animation.Animation,
//   PanoAnimation = com.vizengine.animation.PanoAnimation,
//   DecelerateInterpolator = com.vizengine.animation.DecelerateInterpolator
//
// rootPage = window.rootPage
/* eslint-disable */
import {markerFactories} from './newMarkerFactory'
export const Env = function () {
  let Env = {
    // lunaAblumUrl: "//data.pano.visualbusiness.cn/rest/album/view/",
    queryUrl: '//api.show.vizen.cn',
    // lunaUrl: "//luna.visualbusiness.cn",
    WJPlatformUrl: '//webapp.vizen.cn/wx_show/index.html#/index',
    testEnv: false
  }
  // 本地环境
  if (/-debug|localhost|192\.168|0\.0\.0\.0|env=0/.test(window.location.href)) {
    // Env.lunaAblumUrl = "//datatest.pano.visualbusiness.cn/rest/album/view/",
    // Env.lunaUrl = "//luna-test.visualbusiness.cn";createModelMarker
    Env.queryUrl = '//api.show.test.vizen.cn'
    Env.WJPlatformUrl = '//webapp.vizen.cn/wx_show/index.html#/index'
    Env.testEnv = true
  }
  // 线上环境
  if (/env=1/.test(window.location.href)) {
    // Env.lunaAblumUrl = "//datat.pano.visualbusiness.cn/rest/album/view/",
    // Env.lunaUrl = "//luna.visualbusiness.cn";
    Env.queryUrl = '//api.show.vizen.cn'
    Env.WJPlatformUrl = //webapp.vizen.cn/wx_show/index.html#/index'
    Env.testEnv = false
  }
  // 测试环境
  if (/env=2/.test(window.location.href)) {
    // Env.lunaAblumUrl = "//datatest.pano.visualbusiness.cn/rest/album/view/",
    // Env.lunaUrl = "//luna-test.visualbusiness.cn";
    Env.queryUrl = '//api.show.test.vizen.cn'
    Env.WJPlatformUrl = '//show.test.vizen.cn/weixin/'
    Env.testEnv = true
  }
  // 预生产环境
  if (/env=3/.test(window.location.href)) {
    Env.queryUrl = '//api.show.pre.vizen.cn'
    // Env.lunaAblumUrl = "//datat.pano.visualbusiness.cn/rest/album/view/",
    // Env.lunaUrl = "//luna.visualbusiness.cn";
    Env.WJPlatformUrl = '//webapp.vizen.cn/wx_show/index.html#/index'
    Env.testEnv = false
  }
  // dev环境
  if (/env=4/.test(window.location.href)) {
    Env.queryUrl = '//api.show.dev.vizen.cn'
    Env.WJPlatformUrl = '//show.test.vizen.cn/weixin/'
    Env.testEnv = true
  }
  return Env
}
export const Constant = {
  LocalHead: '/images/head.png',
  WeiboCodeUrl: 'https://api.weibo.com/oauth2/authorize?client_id=2925697724&response_type=code&redirect_uri=' + window.location.href.replace(/&/g, '%26'),
  ShareUrl: (window.location.href.substring(0, window.location.href.indexOf('&code=')) || window.location.href).replace(/(\/v)[0-9]+(.)[0-9]+(.)[0-9]+/, '')
}
export const util = {
  View: function () {
    return com.vizengine.view.View
  },
  TextView: function () {
    return com.vizengine.view.TextView
  },
  ImageView: function () {
    return com.vizengine.view.ImageView
  },
  WebView: function () {
    return com.vizengine.view.WebView
  },
  ListView: function () {
    return com.vizengine.view.ListView
  },
  ScrollView: function () {
    return com.vizengine.view.ScrollView
  },
  formatWXShareImgUrl: function (url) {
    if (url.indexOf("http") === 0) {
      return url
    } else {
      return window.location.protocol + url
    }
  },
  // newAlphaAnimation: new window.com.vizengine.animation.AlphaAnimation(),
  // 路径参数判断页面来源 h5还是小程序 小程序不限拓展功能链接， 不显示微博分享，调整微信分享位置
  sourceFrom: function () {
    if (util.getUrlParam('source') === '1') {
      return 'xcx'
    } else {
      return 'h5'
    }
  },
  // 数字转换万单位  例如110300 转为11万
  intToWan: function (num) {
    var numInner = num
    var numInnerString = num.toString()
    if (numInner > 9999) {
      numInnerString = numInnerString.substr(0, numInnerString.length.toString() - 4) + '万'
      numInner = parseInt(numInnerString)
    }
    return numInnerString
  },
  formatTextBr: function (text) {
    if (typeof text === 'string' && /(↵|\s)/.test(text)) {
      text = text.replace(/\n/g, '<br/>').replace(/↵/g, '<br/>').replace(/\s/g, '&nbsp;')
    }
    return text
  },
  imageLoaded: function (src, callback) {
    var img = new Image()
    img.src = util.WXImage(rootPage, util.setProtocol(src))
    img.onload = function () {
      callback()
    }
  },

  splitEnglishWord: function (word, px, width) {
    word = word || ''

  },

  getAppNeedParamReturnJson: function () {
    var json = {};
    util.getUrlParam('env') ? (json['env'] = util.getUrlParam('env')) : ''
    util.getUrlParam('preview') ? (json['preview'] = util.getUrlParam('preview')) : ''
    util.getUrlParam('audio') ? (json['audio'] = util.getUrlParam('audio')) : ''
    util.getUrlParam('entityId') ? (json['entityId'] = util.getUrlParam('entityId')) : ''

    util.getUrlParam('code') ? (json['code'] = util.getUrlParam('code')) : ''
    util.getUrlParam('photographerId') ? (json['photographerId'] = util.getUrlParam('photographerId')) : ''
    util.getUrlParam('style') ? (json['style'] = util.getUrlParam('style')) : ''
    util.getUrlParam('groupIndex') ? (json['groupIndex'] = util.getUrlParam('groupIndex')) : ''
    util.getUrlParam('panoIndex') ? (json['panoIndex'] = util.getUrlParam('panoIndex')) : ''
    util.getUrlParam('hotelId') ? (json['hotelId'] = util.getUrlParam('hotelId')) : ''
    util.getUrlParam('openid') ? (json['openid'] = util.getUrlParam('openid')) : ''
    util.getUrlParam('source') ? (json['source'] = util.getUrlParam('source')) : ''
    return json;
  },

  getUrlParam: function (name) {
    // var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    // var r = window.location.search.substr(1).match(reg); //匹配目标参数
    // if (r != null) return decodeURIComponent(r[2]);
    // return null; //返回参数值
    // hash
    let search = '?' + window.location.hash.split('?')[1]
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') //构造一个含有目标参数的正则表达式对象
    var r = search.substr(1).match(reg) //匹配目标参数
    if (r != null) {
      return decodeURIComponent(r[2])
    }
    return null //返回参数值
  },

  imgRatio: function (src, callback) {
    var image = new Image()
    image.src = src
    image.onload = function () {
      return callback(image.naturalWidth / image.naturalHeight)
    }
  },

  preload: function () {
    var imageUrls = []
    var callback = null
    for (var i = 0; i < arguments.length; i++) {
      if (arguments[i] instanceof Function) {
        callback = arguments[i]
      } else if (arguments[i] && typeof(arguments[i]) == 'string') {
        imageUrls.push(arguments[i])
      }
    }
    if (!imageUrls.length) {
      callback()
      return
    }
    var loadedCount = 0
    for (var i = 0; i < imageUrls.length; i++) {
      var imgEle = document.createElement('img')
      imgEle.src = imageUrls[i] ? imageUrls[i].replace('http:', window.location.protocol) : ''
      imgEle.onload = function () {
        loadedCount++
        if (loadedCount == imageUrls.length) {
          callback()
        }
      }
    }
  },

  removeSameEle: function (arr) {
    var n = {},
      r = [],
      len = arr.length,
      val, type
    for (var i = 0; i < len; i++) {
      val = arr[i]
      type = typeof val
      if (!n[val]) {
        n[val] = [type]
        r.push(val)
      } else if (n[val].indexOf(type) < 0) {
        n[val].push(type)
        r.push(val)
      }
    }
    return r
  },

  isIphoneX: function () {
    var u = navigator.userAgent
    var isIphoneX = false
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    if (isIOS) {
      if (window.screen.height >= 812 && window.devicePixelRatio >= 2) {
        isIphoneX = true
      }
    }
    return isIphoneX
  },

  isAndroid: function () {
    var u = navigator.userAgent
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
    return isAndroid
  },

  isIOS: function () {
    var u = navigator.userAgent
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    return isIOS
  },

  IsPC: function () {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
      "SymbianOS", "Windows Phone",
      "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    return flag;
  },

  environment: function () {
    let ua = navigator.userAgent;
    return {
      isWeixin: (/MicroMessenger/i).test(ua),
      isQq: (/QQ/i).test(ua),
      isIos: (ua.indexOf('Mac') > -1 && ua.indexOf('Mobile') > -1),
      isAndroid: (ua.indexOf('Mozilla/5.0') > -1 && ua.indexOf('Android ') > -1 && ua.indexOf('AppleWebKit') > -1),
      isWeibo: (ua.indexOf('Weibo') > -1),
      isWinPhone: (ua.indexOf('Windows Phone') > -1)
    }
  },

  isAutoJump: function () {
    let isAutoJump = true
    if (this.getQueryString('isAutoJump') == 'false') {
      isAutoJump = false
    }
    return isAutoJump
  },
  getQueryString: function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
    return null;
  },

  isEmptyObject: function (obj) {
    var name
    for (name in obj) {
      return false
    }
    return true
  },

  isArray: function (o) {
    return Object.prototype.toString.call(o) === '[object Array]'
  },

  setCookie: function (name, value, time) {
    if (time) {
      var exp = new Date()
      exp.setTime(exp.getTime() + time)
      document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString()
    } else {
      document.cookie = name + '=' + escape(value)
    }
  },

  getCookie: function (c_name) {
    let c_start, c_end
    if (document.cookie.length > 0) {
      c_start = document.cookie.indexOf(c_name + '=')
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1
        c_end = document.cookie.indexOf(';', c_start)
        if (c_end == -1) {
          c_end = document.cookie.length
        }
        return unescape(document.cookie.substring(c_start, c_end))
      }
    }
    return ''
  },

  delCookie: function (name) {
    var exp = new Date()
    exp.setTime(exp.getTime() - 1)
    var cval = util.getCookie(name)
    if (cval != null) {
      document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
    }
  },

  tel: function (tel) {
    window.location.href = 'tel:' + tel
  },

  compareByPinyin: function (val1, val2) {
    val1 = val1.toLowerCase()
    val2 = val2.toLowerCase()
    var length = val1.length > val2.length ? val1.length : val2.length
    for (var i = 0; i < length; i++) {
      var differ = val1.charCodeAt(i) - val2.charCodeAt(i)
      if (differ == 0) {
        continue
      } else {
        if (val1.charAt(i) == '_') {
          return -1
        }
        return differ
      }
    }
    if (i == length) {
      return val1.length - val2.length
    }
  },

  distanceFormat: function (dis, lan) {
    // lan ? lan = "zh" : "en";
    var str
    var mStr = lan ? 'm' : '米'
    var kmStr = lan ? 'km' : '公里'
    if (dis <= 1000) {
      str = parseInt(dis) + mStr
    } else if (dis > 1000 && dis < 100000) {
      str = (dis / 1000).toFixed(1) + kmStr
    } else {
      str = parseInt(dis / 1000) + kmStr
    }
    return str
  },

  distanceFormat2: function (dis, lan) {
    // lan ? lan = "zh" : "en";
    var str
    var mStr = lan ? 'm' : '米'
    var kmStr = lan ? 'km' : '公里'
    if (dis <= 1000) {
      str = parseInt(dis) + mStr
    } else if (dis > 1000 && dis < 100000) {
      str = (dis / 1000).toFixed(1) + kmStr
    } else if (dis >= 100000 && dis < 1000000) {
      str = parseInt(dis / 1000) + kmStr
    } else {
      str = '大于999公里'
    }
    return str
  },

  addEventHandler: function (element, type, handler) {
    if (element.addEventListener) {
      element.addEventListener(type, handler, false)
    } else if (element.attachEvent) {
      element.attachEvent('on' + type, handler)
    } else {
      elmenet['on' + type] = handler
    }
  },

  removeEventHandler: function (element, type, handler) {
    if (element.removeEventListener) {
      element.removeEventListener(type, handler, false)
    } else if (element.detachEvent) {
      element.detachEvent('on' + type, handler)
    } else {
      element['on' + type] = null
    }
  },

  // 添加选中状态当前做法均为添加一个border view，控制显示不显示,cell 表示view， 如果index存在表示强制选中哪一个,从0开始
  setSelectState: function (cell, index) {
    for (var i = 0; i < cell.parentView.subViews.length; i++) {
      // cell.parentView.subViews[i].$('pic').setBorderWidth('0dp')
      cell.parentView.subViews[i].$('border').setVisible(false)
    }
    if (index || index == 0) {
      // cell.parentView.subViews[index].$('pic').setBorderWidth('3dp')
      cell.parentView.subViews[index].$('border').setVisible(true)
    } else {
      // cell.$('pic').setBorderWidth('3dp')
      cell.$('border').setVisible(true)
    }
  },


  // 以下方法均需要依赖第三方库
  // 依赖微信JSSDK
  nav: function (lat, lng, name, address) {
    var ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      lat = parseFloat(lat)
      lng = parseFloat(lng)
      var isAndroid = util.isAndroid()
      var scale = isAndroid ? 14 : 11
      try {
        if (wx) {
          wx.openLocation({
            latitude: lat,
            longitude: lng,
            name: name,
            address: address,
            scale: scale,
            infoUrl: '',
            fail: function (res) {
              alert(JSON.stringify(res))
            }
          })
        } else {
          alert('调用地图失败')
        }
      } catch (e) {
        alert('调用地图失败')
      }
    } else {
      window.location.href = '//apis.map.qq.com/uri/v1/routeplan?type=drive&to=' + name + '&tocoord=' + lat + ',' + lng
    }
  },

  // 请求本地数据 依赖jQuery
  // getLocalData: function (url, callback) {
  //   jQuery.getJSON(url, function (data) {
  //     callback(data)
  //   })
  // },
  throttle(fn, wait = 200) {
    let self = this
    if (!self.timer) {
      self.timer = setTimeout(() => {
        self.timer = null
        fn.apply(this, arguments)
      }, wait)
    }
  },

  // 更具经纬度计算两点之间的距离 依赖vizengine库
  getDistance: function (fromLat, fromLon, toLat, toLon) {
    var p1 = new LatLon(fromLat, fromLon)
    var p2 = new LatLon(toLat, toLon)
    var distance = p1.distanceTo(p2)
    return distance
  },

  //计算经纬度对应的heading和pitch
  getHeadingByLatLon: function (fromLat, fromLon, toLat, toLon, angleOffset) {
    // console.log(LatLon)
    var p1 = new LatLon(fromLat, fromLon)
    var p2 = new LatLon(toLat, toLon)
    var angle = p1.bearingTo(p2)
    if (angleOffset) {
      angle -= angleOffset
    }
    return angle
  },

  getPitchByLatLon: function (fromLat, fromLon, toLat, toLon, deltaHeight) {
    if (deltaHeight == null || deltaHeight == 0) {
      deltaHeight = 3
    }
    var p1 = new LatLon(fromLat, fromLon)
    var PI = Math.PI
    var p2 = new LatLon(toLat, toLon)
    var distance = p1.distanceTo(p2)
    return Math.atan(deltaHeight / distance) * 180 / PI
  },

  setOnClick: function (v, callback) {
    if (!v) {
      return
    }
    v.setOnClick(callback || function () {
      return
    })
  },

  setOnClickUnenable: function () {
    if (!arguments.length) {
      return
    }
    $.each(arguments, function (i, view) {
      if (view.setOnClick) {
        view.setOnClick(function () {
          return
        })
      }
    })
  },



  // 动画库
  transYAnim: function () {
    if (arguments.length < 4) {
      console.error('util.transYAnim\'s params error')
      return
    }
    var view = arguments[0]
    var duration = arguments[1]
    var fromY = arguments[2]
    var toY = arguments[3]
    var callback
    var timeInterplator
    if (arguments.length == 5 && typeof arguments[4] == 'function') {
      callback = arguments[4]
    } else if (arguments.length == 5 && typeof arguments[4] != 'function') {
      timeInterplator = arguments[4]
    } else if (arguments.length > 5) {
      timeInterplator = arguments[4]
      callback = arguments[5]
    }
    view.setVisible(true)
    var transY = new TranslateAnimation()
    transY.fromTranslateY = fromY
    transY.toTranslateY = toY
    transY.duration = duration
    transY.callback = callback || null
    if (timeInterplator) {
      transY.timeInterplator = new DecelerateInterpolator(2)
    }
    view.startAnimation(transY)
  },

  transXAnim: function () {
    if (arguments.length < 4) {
      console.error('util.transXAnim\'s params error')
      return
    }
    var view = arguments[0]
    var duration = arguments[1]
    var fromX = arguments[2]
    var toX = arguments[3]
    var callback
    var timeInterplator
    if (arguments.length == 5 && typeof arguments[4] == 'function') {
      callback = arguments[4]
    } else if (arguments.length == 5 && typeof arguments[4] != 'function') {
      timeInterplator = arguments[4]
    } else if (arguments.length > 5) {
      timeInterplator = arguments[4]
      callback = arguments[5]
    }
    view.setVisible(true)
    var transX = new TranslateAnimation()
    transX.fromTranslateX = fromX
    transX.toTranslateX = toX
    transX.duration = duration
    transX.callback = callback || null
    if (timeInterplator) {
      transX.timeInterplator = new DecelerateInterpolator(2)
    }
    view.startAnimation(transX)
  },

  ScaleAnimation: function (v, fromScale, toScale, duration, callback) {
    var anim = new com.vizengine.animation.ScaleAnimation()
    anim.fromScaleX = fromScale
    anim.fromScaleY = fromScale
    anim.toScaleX = toScale
    anim.toScaleY = toScale
    anim.duration = duration
    anim.callback = callback
    v.startAnimation(anim)
  },

  alphaAnimation: function (v, fromAlpha, toAlpha, duration, callback) {
    var animation = new com.appengine.animation.AlphaAnimation()
    animation.timeInterplator = new com.appengine.animation.DecelerateInterpolator(2)
    animation.fromAlpha = fromAlpha
    animation.toAlpha = toAlpha
    animation.duration = duration
    animation.callback = callback

    v.setAlpha(fromAlpha)
    v.setGone(false)
    v.setVisible(true)
    v.startAnimation(animation)
  },

  rotateYAnim: function () {
    if (arguments.length < 2) {
      console.error('util.rotateAnim\'s params error')
      return
    }
    var view = arguments[0]
    var duration = arguments[1]
    var fromY = 0
    var toY = 90
    var callback
    var timeInterplator
    if (arguments.length == 3) {
      callback = arguments[2]
    } else if (arguments.length == 4) {
      fromY = arguments[2]
      toY = arguments[3]
    } else if (arguments.length == 5 && typeof arguments[4] != 'function') {
      fromY = arguments[2]
      toY = arguments[3]
      timeInterplator = arguments[4]
    } else if (arguments.length == 5 && typeof arguments[4] == 'function') {
      fromY = arguments[2]
      toY = arguments[3]
      callback = arguments[4]
    } else if (arguments.length > 5) {
      fromY = arguments[2]
      toY = arguments[3]
      timeInterplator = arguments[4]
      callback = arguments[5]
    }
    var rotateY = new RotateAnimation()
    rotateY.fromRotateY = fromY
    rotateY.toRotateY = toY
    rotateY.duration = duration
    rotateY.callback = callback
    if (timeInterplator) {
      rotateY.timeInterplator = new DecelerateInterpolator(2)
    }
    view.startAnimation(rotateY)
  },

  fadeIn2: function (ele, opacity = 100, speed = 1000) {
    // if (arguments.length < 2) {
    //   console.error('util.fadeIn2\'s params error')
    //   return
    // }
    // var view = arguments[0]
    // var duration = arguments[1]
    // var fromA = 0
    // var toA = 1
    // var callback
    // if (arguments.length == 3) {
    //   callback = arguments[2]
    // } else if (arguments.length == 4) {
    //   fromA = arguments[2]
    //   toA = arguments[3]
    // } else if (arguments.length > 4) {
    //   fromA = arguments[2]
    //   toA = arguments[3]
    //   callback = arguments[4]
    // }
    // view.setAlpha(fromA)
    // var showAnim = new com.vizengine.animation.AlphaAnimation()
    // showAnim.fromAlpha = fromA
    // showAnim.toAlpha = toA
    // showAnim.duration = duration
    // showAnim.callback = callback
    // view.startAnimation(showAnim)
    if (ele) {
      var v = ele.style.filter.replace("alpha(opacity=", "").replace(")", "") || ele.style.opacity;
      v < 1 && (v = v * 100);
      var count = speed / 1000;
      var avg = count < 2 ? (opacity / count) : (opacity / count - 1);
      var timer = null;
      timer = setInterval(function () {
        if (v < opacity) {
          v += avg;
          setOpacity(ele, v);
        } else {
          clearInterval(timer);
        }
      }, 500);
    }
  },
  //pano上的动画
  startPanoAnimation: function (obj) {
    if (!obj || !obj.panoView) {
      return
    }
    var panoView = obj.panoView,
      toHeading = obj.toHeading,
      toPitch = obj.toPitch,
      callback = obj.callback,
      type = obj.type

    var fromHeading = panoView.getHeading() % 360
    if (fromHeading > 180) {
      fromHeading -= 360
    } else if (fromHeading < -180) {
      fromHeading += 360
    }
    var fromPitch = panoView.getPitch() % 360
    // var animation = new com.vizengine.animation.PanoAnimation()
    var animation = {}
    animation.fromHeading = fromHeading
    animation.fromPitch = fromPitch
    animation.fromFov = 100
    var toHeading = toHeading % 360
    if (toHeading > 180) {
      toHeading -= 360
    } else if (toHeading < -180) {
      toHeading += 360
    }
    // 优化框架旋转
    if (toHeading - fromHeading > 180) {
      toHeading -= 360
    } else if (toHeading - fromHeading < -180) {
      toHeading += 360
    }
    animation.toHeading = toHeading
    animation.toPitch = toPitch
    switch (type) {
      case 'enlarge':
        animation.toFov = 40
        break
      case 'shrink':
        animation.toFov = 140
        break
      case 'translation':
        animation.toFov = 80
        break
      case 'normal':
        animation.toFov = 100
        break
      default:
        animation.toFov = 100
        break
    }
    animation.enablePitch = true
    animation.enableHeading = true
    animation.enableFov = true
    animation.duration = 800
    let num = 0
    let progress = 0
    new TWEEN.Tween({ fov: window.pano.getFov() }, window.pano.tweenManager._group)
      .to({ fov: animation.toFov }, animation.duration)
      .onStart(() => {
        window.pano.requestDraw();
      }).onUpdate((obj) => {
        window.pano.camera.fov = obj.fov;
        pano.requestDraw();
      }).easing(TWEEN.Easing.Quadratic.In)
      .onComplete(() => {callback && callback()})
      .start();
    /*
    mySetInterval(function () {
        num++
        progress = num * 20 / animation.duration
        panoView.setFov(animation.fromFov + progress * (animation.toFov - animation.fromFov))
        if (num * 20 >= animation.duration) {
          // clearInterval(panoInterval)
          callback && callback()
          // setTimeout(function () {
          //   panoView.setFov(100)
          // }, 100)
        }
    }, 20, parseInt(animation.duration / 20)
    )
    */
    // callback && callback()

    // let panoInterval = setInterval(() => {
    //   num++
    //   progress = num * 50 / animation.duration
    //   // panoView.setHeading(animation.fromHeading + progress * (animation.toHeading - animation.fromHeading))
    //   // panoView.setHeading(animation.fromPitch + progress * (animation.toPitch - animation.fromPitch))
    //   panoView.setFov(animation.fromFov + progress * (animation.toFov - animation.fromFov))
    //   if (num * 50 > animation.duration) {
    //     clearInterval(panoInterval)
    //     callback && callback()
    //     // setTimeout(function () {
    //     //   panoView.setFov(100)
    //     // }, 100)
    //   }
    // }, 50);
    function mySetInterval (fn, millisec, count) {
      function interval () {
        if (typeof count === 'undefined' || count-- > 0) {
          setTimeout(interval, millisec);
          try {
            fn()
          } catch (e) {
            count = 0;
            throw e.toString();
          }
        }
      }
      setTimeout(interval, millisec)
    }
  },

  panoRotateYAni: function (panoView, fromHeading, toHeading, fromPitch, toPitch, duration, callback) {
    panoView.setHeading(fromHeading)
    panoView.setPitch(fromPitch)
    function mySetInterval (fn, millisec, count) {
      function interval() {
        if (typeof count === 'undefined' || count-- > 0) {
          setTimeout(interval, millisec);
          try {
            fn()
          } catch (e) {
            count = 0;
            throw e.toString();
          }
        }
      }
      setTimeout(interval, millisec)
    };
    let num = 0
    let progress = 0
    setTimeout(() => {
      mySetInterval(() => {
        num++
        progress = num * 20 / duration
        panoView.setHeading(fromHeading + progress * (toHeading - fromHeading))
        // console.log(num)
        if (num * 20 >= duration) {
          // clearInterval(panoInterval)
          callback && callback()
        }
      }, 20, parseInt(duration / 20)
      )
    }, 1000)
  },

  setMaxTxt: function (str, num) {
    if (!str || typeof(str) != 'string') {
      return ''
    }
    return str.length > num ? str.substring(0, num - 1) + '...' : str
  },

  //拆分标题
  getTitleByLine: function (title, type) {
    title = title || ''
    if (title.length <= 7) {
      return [title, '']
    } else if (title.length == 8) {
      return [title.substring(0, 6), title.substring(6)]
    } else {
      if (type == 'album' && window.innerWidth < 330) {
        return [title.substring(0, 7), title.substring(7)]
      }
      return [title.substring(0, 8), title.substring(8)]
    }
  },

  //设置微信title
  setWechartTitle: function (title) {
    document.title = title || '微景平台'
    let iframe = document.createElement('iframe')
    iframe.style.display = 'none';
    iframe.onload = function() {
      setTimeout(() =>{
        iframe.remove();
      }, 30)
    }
    document.body.appendChild(iframe);
  },

  //根据分类设置地图上的marker样式
  setMapMarkerStyleByCategory: function (categoryId) {
    var mapIcon, mapIconActive
    switch (categoryId) {
      case 2:
        mapIcon = '<div class=\'marker_jd\'></div>'
        mapIconActive = '<div class=\'marker_jd_active\'></div>'
        break
      case 3:
      default:
        mapIcon = '<div class=\'marker_bed\'></div>'
        mapIconActive = '<div class=\'marker_bed_active\'></div>'
        break
      case 4:
        mapIcon = '<div class=\'marker_restround\'></div>'
        mapIconActive = '<div class=\'marker_restround_active\'></div>'
        break
      case 5:
        mapIcon = '<div class=\'marker_entertainment\'></div>'
        mapIconActive = '<div class=\'marker_entertainment_active\'></div>'
        break
      case 6:
        mapIcon = '<div class=\'marker_shopping\'></div>'
        mapIconActive = '<div class=\'marker_shopping_active\'></div>'
        break
      case 7:
        mapIcon = '<div class=\'marker_fondation\'></div>'
        mapIconActive = '<div class=\'marker_fondation_active\'></div>'
        break
    }
    return {
      mapIcon: mapIcon,
      mapIconActive: mapIconActive
    }
  },

  //设置统计id
  addStatistics: function (id, cid) {
    if (!id) {
      return
    }
    var mta = document.createElement("script");
    mta.src = "//pingjs.qq.com/h5/stats.js?v2.0.4";
    mta.setAttribute("name", "MTAH5");
    mta.setAttribute("sid", id);
    if (cid) {
      mta.setAttribute("cid", cid);
    }
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(mta, s);
  },

  addMtah5ClickStat: (appId, name, api) => {
    if (window.MtaH5) {
      window.MtaH5.clickStat(name)
      let json = {
        'appId': Number(appId),
        'eventId': name
      }
      api.setPanoMta(json).then(res => {
        // console.log(res)
      })
    }
  },

  //设置正确的协议
  setProtocol: function (url) {
    url = url || ''
    return url.replace(/(^http:\/\/|^https:\/\/|^\/\/)/, window.location.protocol + '//')
  },

  //万象图优化
  WXImage: function (src) {
    src = src || ''
    if (/(cimg)(|[0-9]*)(\.vizen\.cn)/.test(src) && this.frame.width > 0
      && !/(imglarge)/.test(src)) {
      src += '/imglarge'
      if (this.frame.width < 120 && this.frame.width < 120) {
        src += '?imageMogr2/thumbnail/100x/interlace/0'
      } else if (this.frame.width < 220 && this.frame.height < 220) {
        src += '?imageMogr2/thumbnail/200x/interlace/0'
      } else if (this.frame.width < 420 && this.frame.height < 420) {
        src += '?imageMogr2/thumbnail/400x/interlace/0'
      } else if (this.frame.width < 820 && this.frame.height < 820) {
        src += '?imageMogr2/thumbnail/800x/interlace/0'
      } else if (this.frame.width < 1020 && this.frame.height < 1020) {
        src += '?imageMogr2/thumbnail/1000x/interlace/0'
      }
    }
    return src
  },

  panoMarker: {
    set: function (panoView, marker, customClick) {
      var self = this
      this.customClick = customClick
      panoView.markerdata = marker
      panoView.clearMarkers()
      panoView.clearVRMarkers()
      panoView.markerdata = marker
      if (typeof marker === 'object' && marker != null ) {
        let data = JSON.parse(JSON.stringify(marker))
        if (marker.__proto__.constructor == Array) {
          panoView.markerdata = data
        } else {
          for (const key in data) {
            panoView.markerdata = data[key]
          }
        }
      }
      if (panoView.markerdata && panoView.markerdata.length > 0) {
        panoView.markerdata.forEach((item, index) => {
          self.renderMarker(panoView.markerdata[index], panoView)
        });
      }
      self.adaptor = {
        getView: function (index) {
          return self.renderMarker(panoView.markerdata[index], panoView);
        },
        getCount: function () {
          if (panoView.markerdata == null) {
            return 0;
          }
          return panoView.markerdata.length;
        }
      }
    },
    renderMarker: function (marker, panoView) {
      // var cell = markerFactories.markerWraper(marker);
      // markerFactories.markerWraper(marker)
      var self = this
      marker.realName = marker.name
      marker.name = util.setMaxTxt(marker.name, 10)
      if (marker.type == "pano") {
        var part = markerFactories.panoMarker(marker);
      } else if (marker.type == "surround") {
        // 不知道啥原因  产品说没子实体marker
        if (!marker.pitch) {
          marker.pitch = panoView.getPanoId().indexOf('[TT]') === -1 ? marker[panoView.getPanoId()].pitch : marker[panoView.getPanoId().substring(4)].pitch;
        }
        if (!marker.heading) {
          marker.heading = panoView.getPanoId().indexOf('[TT]') === -1 ? marker[panoView.getPanoId()].heading : marker[panoView.getPanoId().substring(4)].heading;
        }
        marker.distanceToH = marker.distanceToH ? marker.distanceToH : util.distanceFormat(marker.distance)
        cell = markerFactories.nearByPoiMarker(marker);
        cell.panoPitch = marker.pitch
        cell.panoHeading = marker.heading
        cell.anchorX = 0.5;
        cell.anchorY = 0.5;
      } else {
        var part = markerFactories.generalMarker(marker);
      }
      // util.fadeIn2(cell, 100);
      part.onclick = function () {
        self.markerClick(marker)
      }
      part.onclickVR = (() => {
        self.markerClick(marker)
      })
      // return cell;
      panoView.addMarker(part);
    },
    markerClick: function (marker) {
      var aniArg = {
        toHeading: marker.heading,
        toPitch: marker.pitch,
        type: "enlarge"
      }
      switch (marker.type) {
        case "pano":
          this.customClick.pano(marker, aniArg)
          break;
        case "surround":
          this.customClick.surround(marker, aniArg)
          break;
        case 'sub':
          this.customClick.sub(marker, aniArg)
          break;
        case "audio":
          this.customClick.audio(marker, aniArg)
          // util.voiceLogic.setMarkerMusic(marker);
          break;
        case "activity":
          this.customClick.activity(marker, aniArg)
          break;
        case "syntheSize":
          this.customClick.syntheSize(marker, aniArg)
          break;
        case "info":
          this.customClick.info(marker, aniArg)
          // rootPage.$("infoMarker").initData({
          //   markerId:marker.id,
          //   title: marker.properties.title || marker.name,
          //   intro: marker.properties.content,
          //   src: marker.properties.pic
          // })
          break;
        case "video":
          this.customClick.video(marker, aniArg)
          // util.voiceLogic.setMarkerVideo(marker)
          break;
        case "panoVideo":
          this.customClick.panoVideo(marker, aniArg)
          // util.voiceLogic.setMarkerVideo(marker)
          break;
        case "threeDModel":
          this.customClick.threeDModel(marker, aniArg)
          // util.createModel3dWrap.getMoreMarkerInfo(marker)
          break;
      }
    }
  },

  model3dMarker: {
    set: (model3dView, markers, customClick, list) => {
      if (typeof(markers) === 'string') {
        markers = JSON.parse(markers)
      }
      for (var i = 0; i < markers.length; i++) {
        var markerData = markers[i]

        // var vec = new com.vizengine.math.Vector3(markerData.x,markerData.y, markerData.z);
        // vec.applyMatrix4(model3dView.rootObject.matrix);
        let marker = document.createElement("div"); // 可以为任意dom元素
        let markerInner = `<div id="model3dmarker${i}" style="cursor: pointer; height: 22px; display: flex; align-items: center;">
                          <div id="imageView" style="width: 11px; height: 11px;">
                            <img src="//panoappstage-1251448083.costj.myqcloud.com/ic_marker.png" style="display: block;width: 11px; height: 11px;">
                          </div>
                          <div id="markerName" style="background: rgb(0, 0, 0); overflow: hidden; border-radius: 10px; margin-left: 3px; height: 18px; color: rgb(255, 255, 255);  padding: 2px 10px;font-size: 14px; line-height: 18px;">
                            ${markerData.name}
                          </div>
                        </div>`
        marker.innerHTML = markerInner
        var createModelMarker = model3dView.createModelMarker(markerData.x, markerData.y, markerData.z, markerData.normal.x, markerData.normal.y, markerData.normal.z);
        marker.anchorX = 0.5
        marker.anchorY = 0.5
        marker.locationX = markerData.x
        marker.locationY = markerData.y
        marker.locationZ = markerData.z
        marker.pointOnModel = createModelMarker;

        marker.worldPosition = createModelMarker.getPosition();
        marker.normal = createModelMarker.normal;
        // 旧版marker点兼容处理
        if (!markerData.pos) {
          var pos = createModelMarker.getPosition().clone();
          model3dView.rootObject.localToWorld(pos);
          markerData.pos = pos
        }
        marker.markerData = markerData;

        // marker.$("markerName")._nativeView.div.style.textShadow = "0px 0px 2px #000000";
        var onMarkerClick = function () {
          customClick.model(this.markerData)
        }
        // marker.$('model3dmarker' + i).setOnClick(onMarkerClick);
        // model.addView(markerView);
        marker.onclick = onMarkerClick
        model3dView.addView(marker);
        list.push(marker)

        // window.rootView.resize();

        // page.$("model3dView").onModelStilledCallback();
      }
    }
  },

  r3dMarker: {
    set: (model3dView, markers, customClick, list) => {
      var styleIcons = {
        text: '//panoappstage-1251448083.costj.myqcloud.com/ic_word.png',
        video: '//panoappstage-1251448083.costj.myqcloud.com/ic_video.png',
        audio: '//panoappstage-1251448083.costj.myqcloud.com/ic_mic.png',
        threeDModel: '//panoappstage-1251448083.costj.myqcloud.com/ic_model.png'
      }

      for (var i = 0; i < markers.length; i++) {
        let markerData = markers[i]
        // var vec = new com.vizengine.math.Vector3(markerData.x,markerData.y, markerData.z);
        // vec.applyMatrix4(model3dView.rootObject.matrix);
        let createModelMarker = model3dView.createModelMarker(markerData.x, markerData.y, markerData.z, markerData.normal.x, markerData.normal.y, markerData.normal.z);
        // let marker = com.vizengine.view.View.parse(
        //   {
        //     id: 'model3dmarker' + i,
        //     layout : "horizontal",
        //     width : "wrap",
        //     height : "wrap",
        //     anchorX : "0.05",
        //     anchorY : "0.5",
        //     locationX : markerData.x,
        //     locationY : markerData.y,
        //     locationZ : markerData.z,
        //     children : [
        //       {
        //         id : "imageView",
        //         type : "ImageView",
        //         width : "17dp",
        //         height : "17dp",
        //         padding : "3dp",
        //         gravity : "center",
        //         src : "//panoappstage-1251448083.costj.myqcloud.com/ic_marker.png"
        //       },
        //       {
        //         id : "markerClickArea",
        //         width : "wrap",
        //         height : "wrap",
        //         layout : "horizontal",
        //         gravity : "center",
        //         background: "#60000000",
        //         borderCorner: "16dp",
        //         clipToBounds: "true",
        //         padding:"2dp 8dp 2dp 8dp",
        //         children : [
        //           {
        //             id : "markerIcon",
        //             type : "ImageView",
        //             width : "22dp",
        //             height : "22dp",
        //             padding : "2dp",
        //             gravity : "center",
        //             src : ""
        //           },
        //           {
        //             id : "markerName",
        //             type : "TextView",
        //             width : "wrap",
        //             height : "wrap",
        //             gravity : "center",
        //             text : "",
        //             fontColor : "#FFFFFF",
        //             // background: "#000000",
        //             fontSize : "14dp",
        //             borderCorner: "10dp",
        //             clipToBounds: "true",
        //           }
        //         ]
        //       }
        //     ]
        //   }
        // )
        let marker = document.createElement("div"); // 可以为任意dom元素
        let markerInner = `<div id="model3dmarker${i}" style="cursor: pointer; height: 22px; display: flex; align-items: center;">
                          <div id="imageView" style="width: 11px; height: 11px;">
                            <img src="//panoappstage-1251448083.costj.myqcloud.com/ic_marker.png" style="display:block;width: 11px; height: 11px;">
                          </div>
                          <div style="display: flex; align-items: center; background: rgb(0, 0, 0);  margin-left: 3px; hidden; border-radius: 10px; padding: 2px 5px">
                            <img id=${markerData.type === 'audio' ? 'marker-sound' : 'marker'} src=${styleIcons[markerData.type]} style="display: inline-block;width: 18px; height: 18px;">
                            <div id="markerName" style="overflow:auto; margin-left: 3px;  height: 18px; color: rgb(255, 255, 255);  font-size: 14px; line-height: 18px;">
                              ${markerData.name}
                            </div>
                          </div>
                        </div>`
        marker.innerHTML = markerInner
        marker.anchorX = 0.5
        marker.anchorY = 0.5
        marker.locationX = markerData.x
        marker.locationY = markerData.y
        marker.locationZ = markerData.z
        marker.pointOnModel = createModelMarker;

        marker.pointOnModel = createModelMarker;
        marker.worldPosition = createModelMarker.getPosition();
        marker.normal = createModelMarker.normal;
        marker.markerData = markerData;

        // marker.$("markerName")._nativeView.div.style.textShadow = "0px 0px 2px #000000";
        let onMarkerClick =  () => {
          console.log(markerData.type)
          switch (markerData.type) {
            case 'text':
              customClick.text(markerData)
              break
            case 'audio':
              customClick.audio(markerData, marker)
              break
            case 'video':
              customClick.video(markerData)
              break
            case 'threeDModel':
              customClick.threeDModel(markerData)
              break
          }

        }
        // marker.$('model3dmarker' + i).setOnClick(onMarkerClick);
        marker.onclick = onMarkerClick
        // marker.$('markerName').setText(markerData.name)
        // marker.$('markerIcon').setSrc(styleIcons[markerData.type])

        model3dView.addView(marker);
        list.push(marker)

        // window.rootView.resize();

        // page.$("model3dView").onModelStilledCallback();
      }
    }
  },

  compareIsObj: function (object) {
    return object && typeof(object) == 'object' && Object.prototype.toString.call(object).toLowerCase() == "[object object]";
  },

  compareIsArray: function (object) {
    return object && typeof(object) == 'object' && object.constructor == Array;
  },

  compareGetLength: function (object) {
    var count = 0;
    for(var i in object) count++;
    return count;
  },

  compare: function (objA, objB) {
    if(!util.compareIsObj(objA) || !util.compareIsObj(objB)) return false; //判断类型是否正确
    if(util.compareGetLength(objA) != util.compareGetLength(objB)) return false; //判断长度是否一致
    return util.compareObj(objA, objB, true); //默认为true
  },

  compareObj: function (objA, objB, flag) {
    for(var key in objA) {
      if(!flag) //跳出整个循环
        break;
      if(!objB.hasOwnProperty(key)) {
        flag = false;
        break;
      }
      if(!util.compareIsArray(objA[key])) { //子级不是数组时,比较属性值
        if(objB[key] != objA[key]) {
          flag = false;
          break;
        }
      } else {
        if(!util.compareIsArray(objB[key])) {
          flag = false;
          break;
        }
        var oA = objA[key],
          oB = objB[key];
        if(oA.length != oB.length) {
          flag = false;
          break;
        }
        for(var k in oA) {
          if(!flag) //这里跳出循环是为了不让递归继续
            break;
          flag = util.CompareObj(oA[k], oB[k], flag);
        }
      }
    }
    return flag;
  },

  pano: {
    //补地水印图片路径
    patchImg: '//panoappstage-1251448083.costj.myqcloud.com/budishuiyin.png',
    markerVisible: function (panoView, visible) {
      panoView.$("leftEye").setVisible(visible)
    },
    setPrefix: function (panoId) {
      panoId = Env().testEnv ? "[TT]" + panoId : panoId;
      return panoId
    },
    /*公用全景回调：marker，zoom，水印，heading、pitch
     *@param pano 参照后台数据
     */
    setPanoIdCCb: function (panoView, pano, customClick, callback) {
      customClick && util.panoMarker && util.panoMarker.set && util.panoMarker.set(panoView, pano.marker, customClick)
      panoView.setHeading(pano.heading ? pano.heading : 0);
      panoView.setPitch(pano.pitch ? pano.pitch : 0);
      if (!util.isWhite) {
        panoView.setWatermarkEnable(true);
      }
      if (pano.panoType && pano.panoType === 2) {
        panoView.addPatch(util.pano.patchImg, 0, 90, 60, 60)
      }
      panoView.setZoom(pano.viewLevel || 0)
      callback && callback()
    },
    setPano: function (panoView, pano, vue, customClick, cb) {
      var self = this
      panoView.markerdata = null;
      let filterName = ''
      !pano.filterTemplateId || pano.filterTemplateId === 'orginal' ? filterName = '' : filterName = pano.filterTemplateId
      // mta统计全景
      util.addMtah5ClickStat(vue.$store.state.appId, 'pano-' + pano.panoId, vue.$api)
      // console.log('pano-' + pano.panoId)
      panoView.setPanoIdAndFilterName(this.setPrefix(pano.panoId), filterName,  () => {
        if (vue.$route.query.panoStyle === 'planet') {
          panoView.clearMarkers()
          util.setPanoPlanet(pano.heading, vue.$route.query.holdTime, () => {
            // 如果开启小行星，则全景的pitch和fov配置都会失效
            pano.pitch = 0
            self.setPanoIdCCb(panoView, pano, customClick, () => {
              if (typeof cb == 'function') cb()
            })
          })
        } else {
          self.setPanoIdCCb(panoView, pano, customClick, () => {
            if (typeof cb == 'function') cb()
          })
        }
      })
      // 湖南酒店特殊处理 2005285945
      if (vue.$store.state.appId === '2005285945') {
        if (vue.status.curPano.panoId === '262F14A0A9A748C883B09B347BB63164') {
          panoView.onHeadingChangeCallback = (heading) => {
            if (heading <= 165) {
              panoView.heading = 165
            }
            if (heading >= 210) {
              panoView.heading = 210
            }
          }
          panoView.onPitchChangeCallback = (pitch) => {
            if (pitch >= 45) {
              panoView.pitch = 45
            }
            if (pitch <= 0) {
              panoView.pitch = 0
            }
          }
        } else {
          panoView.onHeadingChangeCallback = null
          panoView.onPitchChangeCallback =  null
        }
      }
    }
  },
  // 设置三维
  modelSetModelId: function (modelObj, modelInfo, callback) {
    modelInfo.vbrId = modelInfo.vbrId || modelInfo.modelId
    let vbrId = modelInfo.vbrId
    if (vbrId.indexOf('[TT]') !== 0) {
      vbrId = Env().testEnv ? '[TT]' + vbrId : vbrId
    }
    modelObj.onModelLoadedCallback = function () {
      if (location.href.indexOf('1909165375') > -1) {
        modelObj.orbitController.minDistance = 0.1;
        modelObj.orbitController.enablePan = true;
        callback && callback()
      } else {
        callback && callback()
        // var image = new Image()
        // image.setAttribute('crossOrigin', 'anonymous')
        // image.src = '//panoappstage-1251448083.file.myqcloud.com/mobel/modelDecals.png'
        // image.onload = function () {
        //   setTimeout(function () {
        //     modelObj.decals(image)
        //     // console.log(callback)
        //     modelObj.requestDraw()
        //     callback && callback()
        //   }, 1000)
        // }
      }
    }
    modelObj.setModelIdAndJobId(vbrId, modelInfo.path, () => {
      if (modelInfo.pose) {
        let pose
        if (typeof modelInfo.pose === 'string') {
          pose = JSON.parse(modelInfo.pose)
        } else {
          pose = modelInfo.pose
        }
        // 兼容历史数据
        if (pose.pivotVersion) {
          modelObj.reloadPivotInfo(pose)
        } else {
          let data = {
            pivotVersion: 0,
            pose: pose
          }
          modelObj.reloadPivotInfo(data)
          modelObj.orbitController.minDistance = 0.1;
          modelObj.orbitController.enablePan = true;
        }
      }
    })
  },
  // 三维模型添加水印
  modelAddWatermark (model3dView) {
    var image = new Image()
    image.setAttribute('crossOrigin', 'anonymous')
    image.src = '//panoappstage-1251448083.file.myqcloud.com/mobel/modelDecals.png'
    image.onload = () => {
      setTimeout(() => {
        model3dView.requestDraw()
        model3dView.decals(image)
      }, 300)
    }
  },
  // 视频音频时长转时分秒
  translateDurationToShow (duration, layer) {
    function toDouble(num, nextTT) {
      if (num === 0 && nextTT) {
        return '00';
      } else if (num > 0 && num < 10) {
        return '0' + num;
      } else if (num >= 10) {
        return num;
      } else {
        return '';
      }
    }

    var tt = duration % (layer * 60);
    var nextTT = Math.floor(duration / (layer * 60));
    var str = toDouble(tt, nextTT);
    if (!str && !nextTT) {
      return str;
    }
    var nextStr = util.translateDurationToShow(nextTT, layer + 1);
    if (nextStr) {
      str = nextStr + ':' + str;
    }
    if (layer === 1 && String(str).length === 2) {
      str = '00:' + str;
    }
    return str;
  },
  showToast (content) {
    let toast = $('#toast-box')
    if (!!toast.html()) {
      return
    }
    toast.show()
    setTimeout(() => {
      toast.html(content).css('opacity', 1)
    }, 30)
    setTimeout(() => {
      toast.css('opacity', 0)
      setTimeout(() => {
        toast.html('')
        toast.hide()
      }, 500)
    }, 2000)
  },
  RandomNumBoth(Min, Max){
    var Range = Max - Min;
    var Rand = Math.random();
    var num = Min + Math.round(Rand * Range); //四舍五入
    return num;
  },
  panoLoading: {
    dom: null,
    loadingCount: 0,
    timeInterval: null,
    createDom: function () {
      let dom = document.createElement('div')
      dom.style.cssText = "position:fixed ; left: 0; top: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.4); display:flex; align-items: center;justify-content: center; z-index: 0;"
      let domInner = `<div class='pano-loading-container'>
                        <div class="loading-num">0%</div>
                      </div>`
      dom.innerHTML = domInner
      util.panoLoading.dom = dom
      document.body.append(util.panoLoading.dom)
    },
    setCount: function () {
      util.panoLoading.dom.querySelector('.loading-num').innerText = util.panoLoading.loadingCount + '%'
    },
    show: function () {
      if (!util.panoLoading.dom) {
        util.panoLoading.createDom()
      } else {
        util.panoLoading.dom.style.display = 'flex'
      }
      let num = 0
      util.panoLoading.timeInterval = setInterval(() => {
        if (num >= 90) {
          util.panoLoading.loadingCount = 95
          util.panoLoading.setCount()
          clearInterval(util.panoLoading.timeInterval)
        } else {
          num += util.RandomNumBoth(5, 10)
          util.panoLoading.loadingCount = num
          util.panoLoading.setCount()
        }
      }, 200)
    },
    hide: function () {
      if (!document.querySelector('.pano-loading-container')) {
        return
      }
      clearInterval(util.panoLoading.timeInterval)
      // 需要关闭时快速增加，然后关闭
      util.panoLoading.timeInterval =
       setInterval(() => {
        if (util.panoLoading.loadingCount > 80) {
          util.panoLoading.loadingCount = 100
          util.panoLoading.setCount()
          util.panoLoading.dom.style.display = 'none'
          util.panoLoading.loadingCount = 0
          clearInterval(util.panoLoading.timeInterval)
        } else {
          util.panoLoading.loadingCount += 20
          util.panoLoading.setCount()
        }
      }, 50)
    }
   },

  fixPanoVideoUrl (url) {
    return url.replace(/luna-10002033.file.myqcloud.com/, 'cimg.vizen.cn')
  },

  setPanoPlanet (heading = 0, holdTime = 3000, callback) {
    let toFov = util.IsPC() ? 130 : 140
    window.pano.setClickEnable(false)
    window.pano.setAutoPlayEnable(false)
    window.pano.setScaleEnable(false)

    window.pano.setPitch(90)
    window.pano.setPanoEffect(window.vizengine.PanoPlanet)

    let rotateTween = new window.TWEEN.Tween({ heading: heading - (180 + holdTime / 1000 * 6) }, window.pano.tweenGroup)
      .to({
        heading: heading - (90 + holdTime / 1000 * 6)
      }, 2000)
      .onStart(() => {
        window.pano.requestDraw()
      })
      .onUpdate((obj) => {
        window.pano.setHeading(obj.heading)
        window.pano.requestDraw()
      })
      .onComplete(() => {
      })

    let scaleTween = new window.TWEEN.Tween({ fov: 168 }, window.pano.tweenGroup)
      .to({ fov: toFov }, 2000)
      .onStart(() => {
        window.pano.requestDraw()
      })
      .onUpdate((obj) => {
        window.pano.camera.fov = obj.fov
        window.pano.requestDraw()
      })
      .easing(window.TWEEN.Easing.Quadratic.In)
      .start()

    window.spinTween = new window.TWEEN.Tween({ heading: heading - (90 + holdTime / 1000 * 6) }, window.pano.tweenGroup)
      .to({ heading: heading - 90 }, holdTime)
      .onUpdate((obj) => {
        window.pano.setHeading(obj.heading)
      })
      .onComplete(() => {
        panoEnter(callback)
      })

    rotateTween.chain(window.spinTween)
    rotateTween.start()
    scaleTween.start()

    let panoEnter = (callback) => {
      let heading0 = window.pano.getHeading()
      let pitch0 = window.pano.getPitch()
      let fov0 = window.pano.getFov()
      let enterTween = new window.TWEEN.Tween({ heading: heading0, pitch: pitch0, fov: fov0 }, window.pano.tweenGroup)
        .to({ heading: heading, pitch: 0, fov: 90 }, 3000)
        // .to({ heading: 360, pitch: 0, fov: 90 }, 3000)
        .onComplete(() => {
          window.pano.setClickEnable(true)
          window.pano.setAutoPlayEnable(true)
          window.pano.setScaleEnable(true)
          callback && callback()
        })
        .onUpdate((obj) => {
          window.pano.setHeading(obj.heading)
          window.pano.setPitch(obj.pitch)
          window.pano.camera.fov = obj.fov
        })
      window.pano.setPanoEffect(window.vizengine.PanoNormal, 3000)
      enterTween.start()
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js